import { render, staticRenderFns } from "./Footer1.vue?vue&type=template&id=0c6e1c3d&scoped=true"
import script from "./Footer1.vue?vue&type=script&lang=ts"
export * from "./Footer1.vue?vue&type=script&lang=ts"
import style0 from "./Footer1.vue?vue&type=style&index=0&id=0c6e1c3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6e1c3d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFooter,VRow})
